import React from 'react';

type Props = {
    children?: React.ReactNode;
    color?: string;
    containerRef?: React.RefObject<HTMLDivElement>;
};

const Container = React.forwardRef<HTMLDivElement, Props>(({ children, color }, containerRef) => {
    return (
        <div
            className={`container page-content container--${color}`}
            ref={containerRef}
        >
            {children}
        </div>
    );
});

export default Container;
